package one.healthium.meal_plans.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MealPlanInfoDto(
    @SerialName("id") val id: String,
    @SerialName("title") val title: String,
    @SerialName("tags") val tags: List<String> = emptyList(),
)